__turbopack_context__.v({
  "addons-box-header-environmental-icon": "EmailSignatureEditorAddonsEnvironmentalBox-module-scss-module__Q1rKxG__addons-box-header-environmental-icon",
  "addons-selector-environmental-textarea": "EmailSignatureEditorAddonsEnvironmentalBox-module-scss-module__Q1rKxG__addons-selector-environmental-textarea",
});
